<template>
  <WdsStack direction-column gap-xs class="tw-flex-1">
    <slot name="title">
      <WdsText primary>{{ title }}</WdsText>
    </slot>

    <slot />
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack, WdsText } from '@worksome/wds-components'

defineProps<{
  title?: string | null
}>()
</script>
